module.exports = __webpack_public_path__ + "static/media/cpp.8949bfc8.png";